import { ShieldCheck, MonitorPlay, Camera, Cable, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { SERVICES } from "../lib/api";

const ICONS = { ShieldCheck, MonitorPlay, Camera, Cable };

const CAPABILITIES = {
  nac: ["Cloud-managed access platforms", "Mobile credentials & biometrics", "Visitor management & lobby kiosks", "Multi-site role-based policies"],
  av: ["Microsoft Teams & Zoom rooms", "Distributed audio & paging", "Digital signage networks", "Sound masking for open offices"],
  cameras: ["IP camera design (2MP–32MP)", "On-prem NVR or hybrid cloud", "AI analytics: LPR, intrusion, people counting", "Monitoring station integration"],
  cabling: ["Cat6 / Cat6A copper", "OS2 single-mode & OM4 multi-mode fiber", "Patch panel termination & labeling", "BICSI as-built documentation"],
};

export default function ServicesPage() {
  return (
    <div data-testid="services-page" className="bg-[#FAFAFA]">
      <section className="border-b border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 lg:py-20">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#1E3A6B] mb-3">— Services</div>
          <h1 className="font-display font-black tracking-tight text-4xl lg:text-6xl text-slate-900 max-w-3xl">
            Four disciplines. One unified install.
          </h1>
          <p className="mt-6 text-slate-600 max-w-2xl leading-relaxed">
            We design every system to interoperate. Pick one or pick them all — they're
            engineered together from day one.
          </p>
        </div>
      </section>

      {SERVICES.map((s, idx) => {
        const Icon = ICONS[s.icon];
        const caps = CAPABILITIES[s.slug];
        const reverse = idx % 2 === 1;
        return (
          <section key={s.slug} className="border-b border-slate-200" data-testid={`service-section-${s.slug}`}>
            <div className={`max-w-7xl mx-auto px-4 md:px-8 py-20 grid lg:grid-cols-12 gap-12 items-center ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
              <div className="lg:col-span-6">
                <div className="aspect-[4/3] overflow-hidden border border-slate-200 bg-slate-100">
                  <img src={s.image} alt={s.name} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className="lg:col-span-6">
                <div className="inline-flex items-center gap-2 mb-4">
                  <Icon className="text-[#1E3A6B]" size={22} />
                  <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">0{idx + 1} / Capability</span>
                </div>
                <h2 className="font-display font-bold tracking-tight text-3xl lg:text-4xl text-slate-900">{s.name}</h2>
                <p className="mt-4 text-slate-600 leading-relaxed">{s.desc}</p>
                <ul className="mt-6 space-y-2">
                  {caps.map((c) => (
                    <li key={c} className="flex items-start gap-3 text-sm text-slate-700">
                      <Check size={16} className="text-[#1E3A6B] mt-0.5 flex-shrink-0" />
                      {c}
                    </li>
                  ))}
                </ul>
                <div className="mt-8">
                  <Link to="/quote">
                    <Button data-testid={`service-quote-btn-${s.slug}`} className="rounded-none bg-[#1E3A6B] hover:bg-[#172F58] text-white h-11 px-6">
                      Request a Quote for {s.name}
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
